import React, {Component} from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker, lifecycle, InfoWindow } from "react-google-maps"

class MapaModal extends Component{
  constructor(props){
    const searchBoxR = {}
    super(props);
    this.state={
    }
  }


  render(){
    let {coordenadas, showMarker, bounds} = this.state; 
    return(
      <div>
        <GoogleMap
          defaultZoom={12}
          center={this.props.coordenadas}
          onClick={this.props.setMarker}>
          {this.props.showMarker && <Marker position={this.props.coordenadas} 
					/>}
            {this.props.children}
        </GoogleMap>
      </div>
    )
  }
}
export default withScriptjs(withGoogleMap(MapaModal));


// WEBPACK FOOTER //
// ./src/Components/Reservas/mapaModal.js